import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { queryKey as queryKeySubprocessen } from '../../subprocessen/hooks/useSubprocessenForEntity'
import { patchAssignedBijlageForEntity } from '../services/patchAssignedBijlageForEntity'

import { queryKey as queryKeyAssignedBijlagen } from './useAssignedBijlagenForEntity'

export { usePatchAssignedBijlageForEntity }

const usePatchAssignedBijlageForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: patchAssignedBijlageForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyAssignedBijlagen] })
      queryClient.invalidateQueries({ queryKey: [queryKeySubprocessen] })
      successAlert('Bijlage succesvol aangepast')
    },
  })
}
